export default (scene) => {
    const percentText = document.getElementById("loading-percent");
    percentText.innerText = "0%";
    const hook = document.getElementById("brand-image");
    hook.appendChild(percentText);
    scene.load.on('progress', function (value) {
        percentText.innerText = `${Math.floor(value * 100)}%`
    });
}